import React from 'react';
import { method } from '../data/content';
export function Mechanism() {
  return <section aria-labelledby="metodo-titulo" className="w-full bg-navy-800 py-16 text-white sm:py-24" data-id="element-122" data-mp="1m9ecx6vnsf77">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-123" data-mp="1r90tnqap4dkr">
        <div className="max-w-3xl" data-id="element-124" data-mp="1r6oaj9t7bx64">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-ember-400" data-id="element-125" data-mp="1w8dooybq0qyf">
            El mecanismo
          </p>
          <h2 id="metodo-titulo" className="mt-4 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-5xl" data-id="element-126" data-mp="yleo4chwqyv9">
            El Método R.I.A. usa la gravedad cero para crear un vacío en tu columna
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-sand-100/80" data-id="element-127" data-mp="1d9hwttnc4onr">
            En lugar de luchar contra el dolor, posicionamos tu pelvis para que el psoas se relaje y
            la gravedad separe tus vértebras milímetro a milímetro. Es como quitarle el pie al
            freno: cuando liberas la presión, el flujo sanguíneo regresa y el dolor se apaga por
            pura física.
          </p>
        </div>

        <ol className="mt-14 grid gap-px overflow-hidden rounded-2xl bg-white/15 sm:grid-cols-3" data-id="element-128" data-mp="keka6e4u048j">
          {method.map(step => <li key={step.letter} className="flex flex-col bg-navy-800 p-7" data-id="element-129" data-mp="fkzit4xqu8ib">
              <span aria-hidden="true" className="font-display text-5xl font-black leading-none text-ember-500" data-id="element-130" data-mp="bkfm22h316wp">
                {step.letter}
              </span>
              <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-wide" data-id="element-131" data-mp="1lq5cd0x9si1">
                {step.name}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-sand-100/75" data-id="element-132" data-mp="3orqygqykxsrv">{step.body}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}